<template>
  <v-container grid-list-md>
    <v-layout row wrap align-center justify-center fill-height>
      <v-flex xs12 sm8 lg4 md5>
        <v-card class="login-card">
          <v-card-title>
            <span class="headline">Register new account</span>
          </v-card-title>

          <v-spacer />

          <v-card-text>
            <v-layout
              v-if="loading"
              row
              fill-height
              justify-center
              align-center
            >
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
              />
            </v-layout>
            <v-form
              v-else
              ref="form"
              v-model="valid"
              @keyup.native.enter="login"
            >
              <v-container>
                <div class="text-h6 font-weight-bold">ユーザー情報</div>
                <v-divider />
                <v-row>
                  <v-col cols="6">
                    <v-text-field
                      v-model="userInfo.firstname"
                      label="名"
                      :rules="[v => !!v || '名は必須です']"
                      required
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="userInfo.lastname"
                      label="姓"
                      :rules="[v => !!v || '姓は必須です']"
                      required
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="userInfo.affiliation"
                      label="所属"
                      :rules="[v => !!v || '所属は必須です']"
                      required
                      hint="会社に所属する場合、会社と部署名を記載してください。"
                      persistent-hint
                      class="mt-0 pt-0 mb-2"
                      hide-details="auto"
                    />
                  </v-col>
                </v-row>
                <v-text-field
                  v-model="userInfo.email"
                  label="メールアドレス"
                  :rules="[v => !!v || 'メールアドレスは必須です',
                           v => isValidEmail(v) || 'メールアドレスが無効です']"
                  required
                />
                <div class="text-h6 mt-4 font-weight-bold">ログイン情報</div>
                <v-divider />
                <v-text-field
                  v-model="userInfo.username"
                  label="ユーザー名"
                  :rules="[v => !!v || 'ユーザー名は必須です',
                           v => isAlphaNumeric(v) || 'ユーザー名は英数字のみ使用できます']"
                  required
                />
                <v-text-field
                  v-model="userInfo.password"
                  type="password"
                  label="パスワード"
                  :rules="[v => !!v || 'パスワードは必須です',
                           v => isAlphaNumeric(v) || 'パスワードは英数字のみ使用できます']"
                  required
                />
                <v-text-field
                  v-model="confirmedPassword"
                  type="password"
                  label="パスワード確認"
                  :rules="[v => !!v || 'パスワード確認は必須です',
                           v => v === userInfo.password || 'パスワードが一致しません']"
                  required
                />
              </v-container>
              <v-btn
                class="pink white--text"
                :disabled="!valid"
                @click="register"
              >
                Register
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Swal from 'sweetalert2';
import router from '../router';
import { isDisposableEmail } from 'disposable-email-domains-js';

export default {
  name: 'Auth',
  data: () => ({
    userInfo: {},
    confirmedPassword: '',
    valid: false,
    loading: false
  }),
  methods: {
    isValidEmail(email) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return email && !isDisposableEmail(email) && regex.test(email);
    },
    isAlphaNumeric(text) {
      const regex = /^[a-zA-Z0-9]+$/;
      return text && regex.test(text);
    },
    register() {
      if (this.$refs.form.validate() && this.isValidEmail(this.userInfo.email)) {
        this.loading = true;
        const self = this;
        this.api.registerUser(this.userInfo, function(res) {
          self.$store.commit('registration/setRegistrationSuccess', true);
          router.push('/login');
        }, function(errorResponse) {
          self.loading = false;
          if (errorResponse.data.message) {
            Swal.fire({
              icon: 'error',
              title: 'エラー',
              text: errorResponse.data.message || 'Unexpected error occurred. Please contact the administrator.',
              showConfirmButton: true,
              showCloseButton: false
            });
          }
        });
      }
    }
  }
};
</script>
